import { Injectable } from '@angular/core';
import {ValidationErrorService} from './validation-error.service';
import {AlertEventService} from './alert.event.service';
import {SafeHtml} from '@angular/platform-browser';
import {Alert} from './ng-pop-alert.interface';
export class NgPopAlertService {
public alert: Alert = {
    visible: false,
    message: '',
    type: '',
    alert_class: ''
  };
/**
 * @param {?} validationError
 * @param {?} alertEventService
 */
constructor(private validationError: ValidationErrorService,
private alertEventService: AlertEventService) { }
/**
 * Success Alert
 * @param {?} message
 * @return {?}
 */
success(message: SafeHtml | string) {
    this.alert['alert_class'] = 'alert alert-success animated fadeIn';
    this.alert['message'] = message;
    this.alert['visible'] = true;
    this.alert['type'] = 'success';
    this.alertEventService.broadcast('AlertMessage', this.alert);
    return this.alert;
  }
/**
 * Info Alert
 * @param {?} message
 * @return {?}
 */
info(message: SafeHtml | string) {
    this.alert['alert_class'] = 'alert alert-info animated fadeIn';
    this.alert['message'] = message;
    this.alert['visible'] = true;
    this.alert['type'] = 'info';
    this.alertEventService.broadcast('AlertMessage', this.alert);
    return this.alert;
  }
/**
 * Warning Alert
 * @param {?} message
 * @return {?}
 */
warning(message: SafeHtml | string) {
    this.alert['alert_class'] = 'alert alert-warning animated fadeIn';
    this.alert['message'] = message;
    this.alert['visible'] = true;
    this.alert['type'] = 'warning';
    this.alertEventService.broadcast('AlertMessage', this.alert);
    return this.alert;
  }
/**
 * Error Alert
 * @param {?} defaultMessage
 * @param {?=} data
 * @return {?}
 */
error(defaultMessage: SafeHtml | string, data?: String | Object | Array<SafeHtml | string> | Array<Object>) {
    this.alert['alert_class'] = 'alert alert-danger animated fadeIn';
    this.alert['message'] = defaultMessage;
    if (data) {
      this.alert['message'] = this.showError(data, defaultMessage);
    }
    this.alert['visible'] = true;
    this.alert['type'] = 'error';
    this.alertEventService.broadcast('AlertMessage', this.alert);
    return this.alert;
  }
/**
 * This is used to clear alert from display
 * @return {?}
 */
clear() {
    this.alertEventService.broadcast('closeAlertMessage', new Date());
  }
/**
 * This is used to display Error message
 * @param {?} data
 * @param {?} message
 * @return {?}
 */
private showError(data, message) {
    if (data.constructor === Object || data.constructor === Array) {
      return this.validationError.message(data, message);
    } else {
      data = (data.constructor === String) ? data : message;
      return data || message || data['statusText'] || 'Error encountered while processing request, please try again.';
    }
  }

static decorators: DecoratorInvocation[] = [
{ type: Injectable },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: ValidationErrorService, },
{type: AlertEventService, },
];
}

function NgPopAlertService_tsickle_Closure_declarations() {
/** @type {?} */
NgPopAlertService.decorators;
/**
 * @nocollapse
 * @type {?}
 */
NgPopAlertService.ctorParameters;
/** @type {?} */
NgPopAlertService.prototype.alert;
/** @type {?} */
NgPopAlertService.prototype.validationError;
/** @type {?} */
NgPopAlertService.prototype.alertEventService;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
